(ns ductile.ui.carrier-billing
  (:require [clojure.string :as str]
            [ductile.ui.billing :as billing]
            [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.icons :as icons]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.util :as util]
            [ductile.ui.workflow :as workflow]
            [nextjournal.clerk.render :as render]
            [nextjournal.clerk.viewer :as viewer]))



(defn export-link [{:as form :keys [carrier-id]} export-type]
  (str "carrier-billing/" (if carrier-id "export" "bulk-export") "?"
       (util/map->url-encoded-query-params (-> form
                                               (update :carrier-id #(when % (with-out-str (prn %))))
                                               (update :truck-id #(when % (with-out-str (prn %))))
                                               (dissoc :file-upload)
                                               (assoc :export-type export-type)))))

(defn render-preview [{:as p :keys [invoices invoice services-items storage-items transport-items load-items accounting-items billing-error billing-warning billing-errors billing-warnings saved-invoice-id documents]}]
  [:div.pt-10
   (cond
     billing-error
     [billing/render-billing-error billing-error]
     (seq billing-errors)
     [billing/render-billing-errors billing-errors]
     saved-invoice-id
     [billing/render-billing-success saved-invoice-id billing-warning])
   (when (seq billing-warnings)
     [billing/render-billing-warnings billing-warnings])
   (if invoices
     [:div.my-8.mx-auto.max-w-4xl.print:max-w-none.min-h-a4.print-margin
      [:h4.mb-4.page-break-avoid (tr "Invoices")]
      [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} invoices)]]
     invoice)
   (when accounting-items
     [:div.my-8.mx-auto.max-w-full.print:hidden.a4-landscape
      [:h4.mb-4 (tr "Accounting items")]
      [render/inspect (viewer/table accounting-items)]])
   (when (seq (:rows transport-items))
     [:div.my-8.mx-auto.max-w-8xl.print:max-w-none.min-h-a4.print-margin.a4-landscape
      [:h4.mb-4.page-break-avoid (tr "Transports")]
      [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} transport-items)]])
   (when (seq (:rows load-items))
     [:div.my-8.mx-auto.max-w-8xl.print:max-w-none.min-h-a4.print-margin.a4-landscape
      [:h4.mb-4.page-break-avoid (tr "Loads")]
      [render/inspect (viewer/with-viewer (:name viewer/table-viewer) {:nextjournal.clerk/page-size nil} load-items)]])])


(defn render-preview-form [form-map {:as match :keys [query-params]}]
  (let [{:as state} @(deframe/!get-in [])
        compound-name @deframe/!current-compound
        invoice-result (-> state :current-route/transient :result)
        succeeded? (:saved-invoice-id invoice-result)
        update-url! (fn [attrs]
                      (.pushState js/window.history nil nil
                                  (str "?" (util/map->url-encoded-query-params
                                            (-> attrs
                                                (update :carrier-id #(when % (with-out-str (prn %))))))))
                      attrs)]

    (when form-map
      [:div.p-5.print:p-0
       [workflow/form form-map]

       (let [{:keys [carrier-id compounds] :as form} (-> (get-in state (vec (concat [:current-route/transient] (workflow/form-path form-map))))
                                                         ((:form/transform-fn form-map))
                                                         (select-keys [:carrier-id :truck-id :accounting-year-month :compounds :compound-name :billing-year-month]))
             billing-errors (-> state :current-route/transient :billing-errors)]

         [:div.flex.items-center.bg-slate-100.justify-between.p-3.max-w-2xl.mx-auto.rounded-lg.border.border-gray-200.mt-3
          [:div.flex.gap-2
           [:div.flex.items-center
            [ui/button
             {:size 4
              :variant :white
              :href (export-link form "xlsx")
              :class "rounded-r-none"}
             [:div.flex.items-center.gap-2
              icons/excel
              (tr "Download")]]
            [ui/dropdown
             {:button [ui/button {:size 4
                                  :variant :white
                                  :class "rounded-l-none border-l-0 flex items-center px-2"} [ui/icon {:size 16} :chevron-down]]
              :items (if carrier-id
                       [:<>
                        [ui/dropdown-link
                         {:href (export-link form "pdf")}
                         [ui/icon :pdf]
                         (tr "Download PDF Invoice")]
                        [ui/dropdown-link
                         {:href (export-link form "pdf-items")}
                         [ui/icon :pdf]
                         (tr "Download PDF Items")]
                        [ui/dropdown-link
                         {:href (export-link form "xlsx")}
                         [ui/icon :excel]
                         (tr "Download Excel")]
                        [ui/dropdown-link
                         {:href (export-link form "diamant")}
                         [ui/icon :csv]
                         (tr "Download Diamant CSV")]]
                       [:<>
                        [ui/dropdown-link
                         {:href (export-link (assoc form :compound-name compound-name) "speedy-vee-export")}
                         [ui/icon :excel]
                         (str (tr "Download Speedy / VEE Export") " (" compound-name ")")]
                        [ui/dropdown-link
                         {:href (export-link form "monthly-report")}
                         [ui/icon :excel]
                         (str (tr "Download Monatsreport") (when (seq compounds)
                                                             (str " (" (str/join ", " compounds) ")")))]
                        [ui/dropdown-link
                         {:href (export-link form "missing-model-codes")}
                         [ui/icon :excel]
                         (str (tr "Download fehlende Fahrzeugmodelle") (when (seq compounds)
                                                                         (str " (" (str/join ", " compounds) ")")))]])}]]]

          [:div.flex.items-center
           [ui/button {:variant (if succeeded? :white :primary)
                       :on-click (fn []
                                   (update-url! form)
                                   (ui/show-form-modal! 'ductile.carrier-billing/confirm-form form))
                       :size 4
                       :disabled? (or (not carrier-id)
                                      (seq billing-errors)
                                      succeeded?)}
            (cond
              succeeded?
              (tr "Created credit note")
              :else
              (tr "Create credit note"))]]])


       [render-preview invoice-result]])))


